import axios from 'axios';
import qs from 'qs';
import { baseURL } from '../../shared/helpers/axiosConfiguration';

export const getUsersService = (total, offset, limit = 50, searchText = '') => axios({
    method: 'get',
    url: `${baseURL}/dws/user?api_key=setup_manager&orderBy=LastNames&userType=PHONE,VIDEOPHONE&extensionStatus=1&limit=${limit}&offset=${offset}${total ? `&total=${total}` : ''}&searchByText=${searchText}`,
    headers: {
        'Content-Type': 'application/json',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getUserByIDService = id => axios({
    method: 'get',
    url: `${baseURL}/dws/user/userid/${id}?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getUserByExtension = extension => axios({
    method: 'get',
    url: `${baseURL}/dws/user/extension/${extension}?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const createUserService = user => axios({
    method: 'post',
    url: `${baseURL}/dws/user`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        Names: user.Names,
        LastNames: user.LastNames,
        Emails: user.Emails,
        MobileNumber: user.MobileNumber,
        Language: user.Language,
        Status: user.Status,
        UserType: user.UserType,
        Extension: user.Extension,
        ExtensionPassword: user.ExtensionPassword,
        Profiles: user.Profiles,
        Local: user.Local,
        National: user.National,
        International: user.International,
        InterPBX: user.InterPBX,
        Mobile: user.Mobile,
        Special: user.Special,
        Emergency: user.Emergency,
        UseSecurityPin: user.UseSecurityPin,
        SecurityPin: user.SecurityPin,
        ExtensionOnWebEnabled: user.ExtensionOnWebEnabled,
        ExtensionOnMobileEnabled: user.ExtensionOnMobileEnabled,
        UseVoicemail: user.UseVoicemail,
        Monitor: user.Monitor,
        Protocol: user.Protocol,
        RecordingCapacity: user.RecordingCapacity,
        api_key: 'setup_manager'
    })
});

export const uploadUserPhoto = (file, id) => {
    const form = new FormData();

    form.append('file', file);
    form.append('Id', id);
    form.append('filetype', 'user_pic');
    form.append('api_key', 'setup_manager');

    return axios({
        method: 'post',
        url: `${baseURL}/dws/upload`,
        headers: {
            'Content-Type': 'multipart/form-data',
            'x-adminapi-token': localStorage.getItem('token')
        },
        data: form
    });
};

export const updateUserService = (user, id) => axios({
    method: 'put',
    url: `${baseURL}/dws/user/userid/${id}`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        Names: user.Names,
        LastNames: user.LastNames,
        Emails: user.Emails,
        MobileNumber: user.MobileNumber,
        Language: user.Language,
        Status: user.Status,
        UserType: user.UserType,
        ExtensionPassword: user.ExtensionPassword,
        Profiles: user.Profiles,
        Local: user.Local,
        National: user.National,
        International: user.International,
        InterPBX: user.InterPBX,
        Mobile: user.Mobile,
        Special: user.Special,
        Emergency: user.Emergency,
        UseSecurityPin: user.UseSecurityPin,
        SecurityPin: user.SecurityPin,
        ExtensionOnWebEnabled: user.ExtensionOnWebEnabled,
        ExtensionOnMobileEnabled: user.ExtensionOnMobileEnabled,
        UseVoicemail: user.UseVoicemail,
        Monitor: user.Monitor,
        Protocol: user.Protocol,
        RecordingCapacity: user.RecordingCapacity,
        api_key: 'setup_manager'
    })
});

export const deleteUserService = userid => axios({
    method: 'delete',
    url: `${baseURL}/dws/user/userid/${userid}?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getTelephonyProfilesService = () => axios({
    method: 'get',
    url: `${baseURL}/dws/userprofile?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/json',
        'x-adminapi-token': localStorage.getItem('token')
    }
});
